var lib_core = require("lib-core");
var cio_config = require("cio-config");

var WidthHeightData = {
    addWidthHeight: function (width, height){
        this.width = this.value("width", true, cio_config.types.positive_float.validator);
        this.height = this.value("height", true, cio_config.types.positive_float.validator);

        if(width != undefined) this.width(width);
        if(height != undefined) this.height(height);
    },

    scale: function(w, h){
        if (w != undefined) this.width(this.width * w);
        if (h != undefined) this.height(this.height * h);
    }
};

module.exports = WidthHeightData;